import script from "./QandAWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./QandAWidget.vue?vue&type=script&setup=true&lang=js"

import "./QandAWidget.vue?vue&type=style&index=0&id=a057c7f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a057c7f0"]])

export default __exports__